<template>
  <!-- SECTION-PLANOS -->
  <div id="section-planos" class="col-12 p-0 style">
    <div id="header" class="container">
      <router-link v-if="!screen" to="/" class="fa fa-2x fa-times d-lg-flex"></router-link>
      <div class="row mx-0 pt-md-5 pl-md-5 pl-lg-0">
        <div class="d-none d-lg-block col-3 pl-5 ml-3 col-lg-4 pl-lg-4 text-white">
          <h3> Experimente o software gratuitamente por 30 dias e sem compromisso! </h3>
        </div>
        <div
          class="col-10 offset-2 col-md-7 offset-md-2 col-lg-5 offset-lg-1 px-0 d-flex flex-column justify-content-end mt-3">
          <h4><strong style=" color: #ff7f00">Nossos </strong><strong style="color: #ff7f00">Planos:</strong></h4>
          <p style="font-size: 16px">Não tem instalação! Em nuvem, fácil e prático! </p>
        </div>
      </div>
    </div>
    <section>
      <div class="container mt-3">
        <div v-if="recorrencias.length" class="row mx-0">
          <div class="col-12 col-md-10 col-lg-auto mx-auto mb-5 p-0 d-flex bg">
            <div class="row m-0">
              <div v-for="(item, i) in recorrencias" :key="i" @click="periocidade=i"
                :class="periocidade==i ? 'active': ''" class="btn periodo col-6 col-md-3 col-lg-auto text-center">
                <span>{{item.nome}}</span>
                <p class="littletext m-0"> Cobrança a cada {{ item.vencimento }} dias </p>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center pt-5" style="font-size: larger;"><strong>Nenhnum Plano Disponível</strong></div>
        <div v-if="planos.length" class="row mx-0 my-3 planos justify-content-center">
          <div v-for="(item, i) in planos" :key="i" :class="(planos.length <= 2) ? 'col-md-4': 'col-md' "
            class="col-12 p-0 m-0 text-center mb-5">
            <div class="d-flex flex-column justify-content-between bg-white border px-3 px-lg-3 pt-5 m-0"
              :class="[(i==0) ? 'border-left' : '' || (i==(planos.length-1)) ? 'border-right' : '']">
              <div>
                <h2 class="mt-0">{{item.nome}}</h2>
                <h4 v-if="item.descricao">{{item.descricao}}</h4>
                <img :src="require(`@/assets/login/planos/basico${(i<3) ? (i+1) : '1'}.fw.png` || '')"
                  style="width: 100%" alt="">
                <h2 v-if="item.recorrencias" class="mt-0 py-5">
                  <animated-number :value="item.recorrencias[periocidade].valorFinal" :formatValue="formatMoney"
                    :duration="300" />
                  <!-- <span> {{ formatMoney(item.valor)}} </span> -->
                  <span class="smalltext"> {{ periodo }} </span>
                </h2>
              </div>
              <div v-if="item.recorrencias" class="text-left px-3">
                <p><strong>Funcionalidades:</strong></p>
                <p v-for="modulo in item.modulos" :key="modulo.fk_modulo_id">
                  <i class="fa fa-arrow-right text-primary"></i>
                  {{ (modulo.quantidade>0)? `${modulo.quantidade}x` : ''}}
                  {{ modulo.descricao }}
                </p>
                <p class="mt-3 mb-0 text-center">
                  <router-link to="/funcionalidades">Saiba mais</router-link>
                </p>
              </div>
              <div v-else class="text-left">
                <p><i class="fa fa-arrow-right text-primary"></i> Crie seu proprio plano, incluindo todas as suas
                  necessidades</p>
                <p><i class="fa fa-arrow-right text-primary"></i> Conheça todas as <router-link to="/funcionalidades">
                    <u>funcionalidades</u></router-link>
                </p>
              </div>
              <div class="px-3">
                <div v-if="item.recorrencias" class="my-4">
                  <button @click="contratar(item)" class="btn btn-primary py-2 px-3">Contratar</button>
                </div>
                <div v-else class="my-4">
                  <button class="btn btn-primary py-2 px-3" data-toggle="modal"
                    data-target="#mPlanos">Orçamento</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <m-planos />
    <m-termos />
  </div>
</template>

<script>
  import mPlanos from './m-planos.vue';
  import mTermos from '../../auth/components/m-change-termos.vue';
  export default {
    props: ['screen', 'status'],
    components: {
      mPlanos,
      mTermos,
    },
    data() {
      return {
        planoSelected: {
          nome: '',
        },
        planos: [],
        recorrencias: [{
          valorTotal: 0,
        }],
        periocidade: 0,
      }
    },
    beforeMount() {
      this.formatMoney = this.formatMoney.bind(this);
      this.$store.dispatch('getPlanosPublico');
      this.planos = this.$store.state.plano.publicSelect;
      if ((this.$store.state.plano.publicSelect).length)
        this.recorrencias = this.$store.state.plano.publicSelect[this.periocidade].recorrencias;
      this.planos.push({
        nome: "Personalizado",
      })
    },
    computed: {
      periodo() {
        switch (this.periocidade) {
          case 0:
            return '/Mês'
          case 1:
            return '/Trimestre'
          case 2:
            return '/Semestre'
          case 3:
            return '/Anual'
          default:
            return '/Mês';
        }
      }
    },
    methods: {
      contratar(payload) {
        this.planoSelected = {
          ...payload
        };
        this.planoSelected.recorrencias = this.recorrencias[this.periocidade];
        // $('#mPlanos').modal('toggle');
        this.$router.push({
          name: 'loginIndex',
          params: {
            plano: {
              item: this.planoSelected,
            }
          }
        }).catch(() => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
          this.status.box = 'cadastrar';
          this.status.plano = {
            item: this.planoSelected
          };
        });
      },
      limpar() {
        this.planoSelected = {};
      }
    },
  }
</script>


<style scoped src="@/assets/sass/bootstrap.min.css"></style>
<style scoped>
  a.fa-times {
    color: #ff4d4d;
    text-decoration: none;
    cursor: pointer;
    position: fixed;
    top: 3vw;
    left: 1.5vw;
    z-index: 20;
  }

  [id*='section-'] {
    background-color: #f8f9fa !important;
    font-family: 'Montserrat';
    min-height: 100vh;
    /* z-index: 10; */
  }

  #header h4 {
    font-size: 32px;
    line-height: 1.1875;
    font-family: "Montserrat";
  }

  #header h3 {
    font-size: 24px;
  }

  .style {
    overflow: hidden !important;
  }

  .style:before {
    content: '';
    height: 150vh;
    width: 100vw;
    background-color: #4464d8 !important;
    transform: rotate(-35deg);
    -webkit-transform: rotate(-35deg);
    position: absolute;
    top: -20vw;
    left: -50vw;
    z-index: 0;
  }

  .btn.periodo {
    background-color: white;
    color: #4464d8;
    transition: all 0.5s;
  }

  .btn.periodo.active {
    color: white;
    font-weight: 600;
    background-color: rgb(92, 92, 92);
    border-radius: 5px;
  }

  .bg {
    border-radius: 5px;
    border: 2px solid rgb(92, 92, 92);
    background-color: transparent;
  }

  .bg-white {
    width: 100%;
    height: 100%;
    color: #4464d8;
    border: 1px solid #4464d8;
    border-left: 0;
    position: relative;
  }

  .bg-white h2 {
    font-size: 30px;
  }

  .bg-white h4 {
    font-size: 18px;
    font-weight: 300;
  }

  .bg-white .text-left {
    color: #333333aa;
    /* padding-bottom: 100px; */
  }

  .bg-white.border {
    border-radius: 0;
  }

  .bg-white.border-left {
    border-radius: 15px 0 0 15px;
  }

  .bg-white.border-right {
    border-radius: 0 15px 15px 0;
  }

  .littletext {
    font-size: 9px;
    font-weight: 500;
  }

  .smalltext {
    font-size: medium;
    align-items: center;
  }

  div.position-absolute {
    left: calc(50% - 37.135px);
    bottom: 15px;
  }

  .btn-primary {
    font-size: 14px;
  }

  @media screen and (min-width: 1024px) {
    .style:before {
      top: 0vh;
    }
  }

  @media screen and (max-width: 1024px) {
    .style:before {
      top: -15vh;
    }
  }

  @media screen and (max-width: 992px) {
    #header h4 {
      font-size: 26px;
    }

    #header h3 {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 767px) {
    .bg-white {
      border: 1px solid #4464d8;
    }

    .bg-white.border {
      border-radius: 15px;
    }
  }

  @media screen and (max-width: 425px) {
    .style:before {
      top: -5vh;
      left: 0vw;
      transform: rotate(-14.3deg);
      -webkit-transform: rotate(-15deg);
    }
  }
</style>